/*eslint-disable react/no-unused-state*/
import _ from 'lodash'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { divisionPlayerFilter } from '../../../utils/functions';
import { DIVISIONS, PlayersHeaders } from '../../../utils/constants';
import Navwrapper from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getTeamPlayersBySeason, getSeasonsRanking } from '../api'
import { exportCSV, tableOptions } from '../common'

export default class TeamPlayersPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      seasons: [],
      playersData: [],
      seasonId: 0,
      currentSeason: '',
      playersTitle: "Players Averages"
    };
    this.handleActiveSeasonChange = this.handleActiveSeasonChange.bind(this);
  }

  componentDidMount() {
    const _this = this
    getSeasonsRanking().then(function(response) {
      const seasons = response.data
      _this.setState({ currentSeason: response.data[0].seasonName });
      _this.setState({ seasonId: seasons[0].seasonId });
      //   _this.setState({pageTitle:'Traditional Avg. All Events Top Players'})

      const teamId = _this.props.match.params.teamId;

      if (teamId) {
        getTeamPlayersBySeason(_this.state.seasonId, teamId).then(
          function(response) {
            _this.setState({ playersData: response.data });
          });
      }

      _this.setState({ seasons: seasons });
    });
  }

  setActiveSeasonsOptions() {
    const { seasons } = this.state
    const option = seasons.map((season) => {
      return (<option value={season.seasonId} key={season.seasonId}>{season.seasonName}</option>)
    })
    return option
  }

  handleActiveSeasonChange(event) {
    const _this = this;
    const seasonId = event.target.value;
    const selectedSeason = _.find(_this.state.seasons, ['seasonId', parseInt(seasonId)]);
    _this.setState({ currentSeason: selectedSeason.seasonName });
    _this.setState({ seasonId: seasonId });

    const teamId = _this.props.match.params.teamId;

    if (teamId) {
      getTeamPlayersBySeason(seasonId, teamId).then(
        function (response) {
          _this.setState({ playersData: response.data })
        }).catch(_this.setState({ playersData: [] }));
    }
  }

  playerNameFormatter(cell, row) {
    const link = `/playerProfile/${row.seasonId}/${row.playerId}`;
    return <Link to={link}>{cell}</Link>;
  }
  
  render() {
    const _this = this;
    const playersAll = this.state.playersData;
    const menPlayers = playersAll.filter((dataItem) => divisionPlayerFilter(dataItem, DIVISIONS.MENPLAYERS));
    const womenPlayers = playersAll.filter((dataItem) => divisionPlayerFilter(dataItem, DIVISIONS.WOMENPLAYERS));
    return (
      <div>
        <Navwrapper />

        <div className="container-fluid">
          <Row>
            <div className="pageHeading" >
              <div className="archiveDropDown">
                <div >
                  <div className="titleWrap">
                    <label className="archiveLabel">Past Season: </label>
                  </div>
                  <div className="valueWrap" >
                    <select onChange={this.handleActiveSeasonChange}>
                      {this.setActiveSeasonsOptions()}
                    </select>
                  </div>
                </div>
              </div>
              <h4>
                {_this.state.currentSeason}
              </h4>
              <h4 >
                {_this.state.playersTitle}
              </h4>
            </div>
          </Row>
          <Row>
            <Col xs={10} >
              <div className="playersRightColumn_">
                <Tabs defaultActiveKey={1} id="players-results-tabs">
                  <Tab eventKey={1} title="MEN">
                    <BootstrapTable
                      data={menPlayers}
                      striped
                      hover
                      options={tableOptions}
                      pagination
                    >
                      <TableHeaderColumn
                        dataField="Id"
                        isKey
                        dataAlign="right"
                        data-Visible="false"
                        hidden
                      >ID
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="no" width="2%" >NO
                                    </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="playerName"
                        dataFormat={_this.playerNameFormatter}
                        width="10%"
                      >Name
                                    </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="schoolName"
                        width="10%"
                      >SCHOOL
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="gm" dataAlign="right" width="2%" >GM
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="avg" dataAlign="right" width="6%" dataSort >AVG
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="e" dataAlign="right" width="2%" >E
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="top1" dataAlign="right" width="2%" >1
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="top5" dataAlign="right" width="2%" >5
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="top10" dataAlign="right" width="2%" >10
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="top25" dataAlign="right" width="2%" >25
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="favg" dataAlign="right" width="6%" >F-AVG
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="adiff" dataAlign="right" width="6%" dataSort>A-DIFF
                                    </TableHeaderColumn>
                    </BootstrapTable>
                    {exportCSV(menPlayers, PlayersHeaders, 'MenPlayers.csv')}
                  </Tab>
                  <Tab eventKey={2} title="WOMEN">
                    <BootstrapTable
                      data={womenPlayers}
                      striped
                      hover
                      options={tableOptions}
                      pagination
                    >
                      <TableHeaderColumn
                        dataField="Id"
                        isKey
                        dataAlign="right"
                        data-Visible="false"
                        hidden
                      >ID
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="no" width="2%" >NO
                                    </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="playerName"
                        dataFormat={_this.playerNameFormatter}
                        width="10%"
                      >Name
                                    </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="schoolName"
                        width="10%"
                      >SCHOOL
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="gm" dataAlign="right" width="2%" >GM
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="avg" dataAlign="right" width="6%" dataSort>AVG
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="e" dataAlign="right" width="2%" >E
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="top1" dataAlign="right" width="2%" >1
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="top5" dataAlign="right" width="2%" >5
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="top10" dataAlign="right" width="2%" >10
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="top25" dataAlign="right" width="2%" >25
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="favg" dataAlign="right" width="6%" >F-AVG
                                    </TableHeaderColumn>
                      <TableHeaderColumn dataField="adiff" dataAlign="right" width="6%" dataSort>A-DIFF
                                    </TableHeaderColumn>
                    </BootstrapTable>
                    {exportCSV(womenPlayers, PlayersHeaders, 'WomenPlayers.csv')}
                  </Tab>
                </Tabs>
              </div>
            </Col>
          </Row>
        </div>
        <Footer />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/teamPlayers/index.js